import { InformationCircleIcon } from '@heroicons/react/16/solid';
import React, { forwardRef } from 'react';
import { tv, VariantProps } from 'tailwind-variants';
import { FieldWrapper } from './FieldWrapper';
import { BaseTextArea } from './BaseTextArea';

const style = tv({
  variants: {
    rounded: {
      md: 'rounded-md',
      lg: 'rounded-lg',
      xl: 'rounded-xl',
      '2xl': 'rounded-2xl',
      '3xl': 'rounded-3xl',
    },
    error: {
      true: 'border-red-600',
    },
    disabled: {
      true: 'bg-gray-100',
    },
  },
  defaultVariants: {
    rounded: 'md',
  },
});

type TextAreaProps = Omit<React.ComponentProps<typeof BaseTextArea>, 'label'> &
  VariantProps<typeof style> & {
    label?: React.ReactNode;
    errors?: string[];
  };

export const TextArea = forwardRef<HTMLTextAreaElement, TextAreaProps>(
  ({ label, rounded, className, error, errors, ...props }, ref) => {
    return (
      <FieldWrapper label={label}>
        <BaseTextArea
          ref={ref}
          className={style({
            error,
            rounded,
            className,
            disabled: props.disabled,
          })}
          {...props}
        />

        {error && errors && (
          <div className="mt-1 flex-col items-center text-sm text-red-600">
            {errors.map((message: string) => (
              <div key={message} className="flex items-center">
                <InformationCircleIcon className="mr-1 size-4" />
                {message}
              </div>
            ))}
          </div>
        )}
      </FieldWrapper>
    );
  }
);

TextArea.displayName = 'TextArea';
